<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.operate-btns {
  display: flex;
  justify-content: center;
}

.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="function-wrap">
      <span>{{ subTitle }}</span>
      <div class="back-btn" @click="$router.go(-1)">返回</div>
    </div>
    <div class="search-area" style="margin-bottom: 0;">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">变更人</div>
          <el-input multiple size="mini" class="ipt-sty" v-model="page.createUserSearchKey" filterable placeholder="请输入">
          </el-input>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">变更日期</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="timeRange" type="daterange" align="left" unlink-panels
            range-separator="-" start-placeholder="起始日期" end-placeholder="截止日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">变更内容</div>
          <el-input multiple size="mini" class="ipt-sty" v-model="page.changeContent" filterable placeholder="请输入">
          </el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <el-table ref="elTable" :data="tableData" :height="tableHeight" stripe border style="width: 100%"
        v-loading="tableLoading">
        <el-table-column fixed="left" label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column width="126" label="变更日期" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getTime }}</template>
        </el-table-column>

        <el-table-column width="90" label="变更方式" header-align="center" align="left">
          <template slot-scope="scope">
            <div :class="index != 0 ? 'more-design design more-design1' : 'design more-design1'" v-html="item.type"
              v-for="(item, index) in  scope.row.changeContentList" :key="index">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="变更内容" header-align="center" align="left">
          <template slot-scope="scope">
            <el-popover placement="top" width="400" trigger="hover" v-for="(item, index) in  scope.row.changeContentList"
              :key="index">
              <div v-html="item.changeContent"></div>
              <div :class="index != 0 ? 'more-design design' : 'design'" slot="reference" v-html="item.changeContent"></div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column width="90" label="变更人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>

        <!-- <el-table-column  width="300" label="变更客户权限" header-align="center" align="left">
          <template slot-scope="scope">
              <div v-html="item" v-for="(item,index) in  scope.row.customerPermissionChangeList" :key="index">
              </div>
              <div v-if="!scope.row.customerPermissionChangeList">-</div>
            </template>
        </el-table-column>
        <el-table-column  width="300" label="变更执行规则" header-align="center" align="left">
          <template slot-scope="scope">
            <div v-html="item" v-for="(item,index) in  scope.row.taskLimitRuleChangeList" :key="index">
            </div>
            <div v-if="!scope.row.taskLimitRuleChangeList">-</div>
          </template>
        </el-table-column>
          <el-table-column  width="300" label="变更拍照与签到" header-align="center" align="left">
            <template slot-scope="scope">
              <div v-html="item" v-for="(item,index) in  scope.row.photoSignChangeList" :key="index">
              </div>
              <div v-if="!scope.row.photoSignChangeList">-</div>
            </template>
        </el-table-column>
        <el-table-column  width="300" label="其他规则" header-align="center" align="left">
          <template slot-scope="scope">
              <div v-html="item" v-for="(item,index) in  scope.row.campaignsState" :key="index">
              </div>
              <div v-if="!scope.row.campaignsState">-</div>
          </template>
        </el-table-column> -->

        <el-table-column prop="bank" width="100px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="seeForm(scope.row.guid, scope.$index)">查看当时配置</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memoryScrollTop: 0,
      subTitle: null,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,

      timeRange: [],
      page: {
        changeContent: null,
        createUserSearchKey: null,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        startDate: null,
        endDate: null,
      },
      right: 'right',
      tableData: [],
    };
  },
  created() {
    this.subTitle = localStorage.threeLevels + '变更日志';
    this.page.functionTenantGuid = this.$route.query.guid,
    this.getList();
  },
  activated() {
    this.$nextTick(() => {
      this.page.functionTenantGuid = this.$route.query.guid,
      this.getList();
      this.getTableScrollTop()
    })
  },
  methods: {
    /**
    * @description: 获取表格滚动条位置
    * @param index 有没有 index 决定了该函数是保存位置还是跳转位置
    * @return void
    */
    getTableScrollTop(index) {
      if (!this.$refs['elTable']) return //不存在这个表格则返回
      let elTable = this.$refs['elTable'].$el
      if (!elTable) return
      const scrollParent = elTable.querySelector('.el-table__body-wrapper')
      if (index) {
        const targetTop = elTable.querySelectorAll('.el-table__body tr')[index].getBoundingClientRect().top //该行的位置
        const containerTop = elTable.querySelector('.el-table__body').getBoundingClientRect().top //body的位置
        //保存
        this.memoryScrollTop = targetTop - containerTop //存下当前编辑行的ScrollTop
      } else {
        //跳转
        setTimeout(() => {
          scrollParent.scrollTop = this.memoryScrollTop //跳转到存下编辑行的ScrollTop
        })
      }
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (!self.timeRange || self.timeRange.length != 0) {
        self.page.startDate = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endDate = self.timeRange[1] + ' ' + '23:59:59';
      }
      var req = JSON.parse(JSON.stringify(this.page));
      self.api.postJson(`/${serverConfig.msConfigureService}/function/page-list-change-history`, req).then(res => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.page));
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/function/page-list-change-history`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        functionTenantGuid: this.$route.query.guid,
        changeContent: null,
        createUserSearchKey: null,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        startDate: null,
        endDate: null,
      };
      this.timeRange = [];
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    //查看
    seeForm(logGuid, index) {
      let query = {
        functionGuid: this.$route.query.functionGuid,
        functionCode: this.$route.query.functionCode,
        productGuid: this.$route.query.productGuid,
        logGuid: logGuid,
        subTitle: localStorage.threeLevels + '历史配置',
        type: 3
      };
      this.getTableScrollTop(index);
      let path = '/h5ConfigFieldAdd';
      this.$router.push({
        path,
        query,
      });
    }
  }
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.search-area-div {
  width: 60px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}

.import-step-tip {
  color: #999;
  line-height: 25px;
  font-size: 12px;
}

.function-wrap {
  position: relative;
  height: 50px;
  line-height: 30px;
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
  border-bottom: 1px solid #D9D9D9;
  background: #fff;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.back-btn {
  position: absolute;
  top: 12px;
  left: 10px;
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}

.rule-content {
  display: flex;
  padding: 5px 0;
}

.rule-content .ru-title {
  word-break: keep-all;
  color: #000;
  font-weight: 600;
  padding-right: 10px;

}

/deep/ td:nth-child(3) .cell {
  padding: 0;
}

/deep/ td:nth-child(4) .cell {
  padding: 0;
}

.design {
  padding: 10px;
  height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.more-design {
  border-top: 1px solid #d9d9d9
}

.more-design1 {
  line-height: 60px;
}</style>
